import React, {Component} from 'react';

let GEPostPath = 1;
let GEPostData = require('../json/' + GEPostPath + '.json');
let Lesson = require('../json/lesson.json');
let todos = GEPostData;
const list = [
  {
    no: 1,
    name: '南勢阿美語',
  },
  {
    no: 2,
    name: '秀姑巒阿美語',
  },
  {
    no: 3,
    name: '海岸阿美語',
  },
  {
    no: 4,
    name: '馬蘭阿美語',
  },
  {
    no: 5,
    name: '恆春阿美語',
  },
  {
    no: 6,
    name: '賽考利克泰雅語',
  },
  {
    no: 7,
    name: '澤敖利泰雅語',
  },
  {
    no: 8,
    name: '汶水泰雅語',
  },
  {
    no: 9,
    name: '萬大泰雅語',
  },
  {
    no: 10,
    name: '四季泰雅語',
  },
  {
    no: 11,
    name: '宜蘭澤敖利泰雅語',
  },
  {
    no: 12,
    name: '缺',
  },
  {
    no: 13,
    name: '賽夏語',
  },
  {
    no: 14,
    name: '邵語',
  },
  {
    no: 15,
    name: '都達語',
  },
  {
    no: 16,
    name: '德固達雅語',
  },
  {
    no: 17,
    name: '德路固語',
  },
  {
    no: 18,
    name: '卓群布農語',
  },
  {
    no: 19,
    name: '卡群布農語',
  },
  {
    no: 20,
    name: '丹群布農語',
  },
  {
    no: 21,
    name: '巒群布農語',
  },
  {
    no: 22,
    name: '郡群布農語',
  },
  {
    no: 23,
    name: '東排灣語',
  },
  {
    no: 24,
    name: '北排灣語',
  },
  {
    no: 25,
    name: '中排灣語',
  },
  {
    no: 26,
    name: '南排灣語',
  },
  {
    no: 27,
    name: '東魯凱語',
  },
  {
    no: 28,
    name: '霧台魯凱語',
  },
  {
    no: 29,
    name: '大武魯凱語',
  },
  {
    no: 30,
    name: '多納魯凱語',
  },
  {
    no: 31,
    name: '茂林魯凱語',
  },
  {
    no: 32,
    name: '萬山魯凱語',
  },
  {
    no: 33,
    name: '太魯閣語',
  },
  {
    no: 34,
    name: '噶瑪蘭語',
  },
  {
    no: 35,
    name: '鄒語',
  },
  {
    no: 36,
    name: '卡那卡那富語',
  },
  {
    no: 37,
    name: '拉阿魯哇語',
  },
  {
    no: 38,
    name: '南王卑南語',
  },
  {
    no: 39,
    name: '知本卑南語',
  },
  {
    no: 40,
    name: '初鹿卑南語',
  },
  {
    no: 41,
    name: '建和卑南語',
  },
  {
    no: 42,
    name: '雅美語',
  },
  {
    no: 43,
    name: '撤奇萊雅語',
  },
];
console.log(`Lesson: `, Lesson);
class GEVideo extends Component {
  constructor(props) {
    super(props);
    this.gotoVideo = this.gotoVideo.bind(this);
    this.preLesson = this.preLesson.bind(this);
    this.nextLesson = this.nextLesson.bind(this);
    this.returnTo = this.returnTo.bind(this);
    this.openList = this.openList.bind(this);
    this.changeList = this.changeList.bind(this);
    this.showList = this.showList.bind(this);
    this.state = {
      videoNo: 0,
      corretName: '南勢阿美語',
      abMain: 0,
      videoPage: false,
      todos: GEPostData,
      abList: false,
    };
  }

  openList(e) {
    this.setState({
      abMain: e.currentTarget.value,
    });
    console.log(`abMain: `, this.state.abMain);
  }
  showList() {
    this.setState((prevState) => ({
      abList: !prevState.abList,
    }));
  }
  changeList(e) {
    GEPostPath = e.currentTarget.value;
    GEPostData = require('../json/' + GEPostPath + '.json');
    this.setState({
      todos: GEPostData,
      corretName: list[GEPostPath - 1].name,
      videoPage: false,
      abList: false,
      abMain: 0,
    });
    console.log(`Target Value: `, e.currentTarget.value);
  }

  gotoVideo(e) {
    this.setState({
      videoPage: true,
      abList: false,
      videoNo: e.currentTarget.value - 1,
    });
  }

  preLesson() {
    this.setState((prevState) => {
      return {videoNo: prevState.videoNo - 1};
    });
  }

  nextLesson() {
    this.setState((prevState) => {
      return {videoNo: prevState.videoNo + 1};
    });
  }

  returnTo() {
    this.setState({
      videoPage: false,
    });
  }

  render() {
    let todos = this.state.todos;
    return (
      <div>
        <div>
          <div className='languageMargin'>
            <div className='languageBox'>
              <div className='languageImgA'></div>
              <div>
                <div className='languageNow'>
                  目前語言：{this.state.corretName}
                </div>
              </div>
              <div>
                <button
                  onClick={this.showList}
                  className={
                    this.state.abList ? 'languageBtnA' : 'languageBtnB'
                  }></button>
              </div>
              {this.state.abList && (
                <div className='languageCloseBox'>
                  <button
                    className='languageClose'
                    onClick={this.showList}></button>
                </div>
              )}
            </div>
            {this.state.abList && (
              <div>
                <div className='listBtnA'>
                  <button onClick={this.openList} value={1}>
                    阿美語
                  </button>
                  <button onClick={this.openList} value={2}>
                    泰雅語
                  </button>
                  <button onClick={this.changeList} value={13}>
                    賽夏語
                  </button>
                  <button onClick={this.changeList} value={14}>
                    邵語
                  </button>
                  <button onClick={this.openList} value={3}>
                    賽德克語
                  </button>
                  <button onClick={this.openList} value={4}>
                    布農語
                  </button>
                  <button onClick={this.openList} value={5}>
                    排灣語
                  </button>
                  <button onClick={this.openList} value={6}>
                    魯凱語
                  </button>
                </div>
                {this.state.abMain == 1 && (
                  <div className='listBtnB'>
                    <button onClick={this.changeList} value={1}>
                      南勢阿美語
                    </button>
                    <button onClick={this.changeList} value={2}>
                      秀姑巒阿美語
                    </button>
                    <button onClick={this.changeList} value={3}>
                      海岸阿美語
                    </button>
                    <button onClick={this.changeList} value={4}>
                      馬蘭阿美語
                    </button>
                    <button onClick={this.changeList} value={5}>
                      恆春阿美語
                    </button>
                  </div>
                )}
                {this.state.abMain == 2 && (
                  <div className='listBtnB'>
                    <button onClick={this.changeList} value={6}>
                      賽考利克泰雅語
                    </button>
                    <button onClick={this.changeList} value={7}>
                      澤敖利泰雅語
                    </button>
                    <button onClick={this.changeList} value={8}>
                      汶水泰雅語
                    </button>
                    <button onClick={this.changeList} value={9}>
                      萬大泰雅語
                    </button>
                    <button onClick={this.changeList} value={10}>
                      四季泰雅語
                    </button>
                    <button onClick={this.changeList} value={11}>
                      宜蘭澤敖利泰雅語
                    </button>
                  </div>
                )}
                {this.state.abMain == 3 && (
                  <div className='listBtnB'>
                    <button onClick={this.changeList} value={15}>
                      都達語
                    </button>
                    <button onClick={this.changeList} value={16}>
                      德固達雅語
                    </button>
                    <button onClick={this.changeList} value={17}>
                      德路固語
                    </button>
                  </div>
                )}
                {this.state.abMain == 4 && (
                  <div className='listBtnB'>
                    <button onClick={this.changeList} value={18}>
                      卓群布農語
                    </button>
                    <button onClick={this.changeList} value={19}>
                      卡群布農語
                    </button>
                    <button onClick={this.changeList} value={20}>
                      丹群布農語
                    </button>
                    <button onClick={this.changeList} value={21}>
                      巒群布農語
                    </button>
                    <button onClick={this.changeList} value={22}>
                      郡群布農語
                    </button>
                  </div>
                )}
                {this.state.abMain == 5 && (
                  <div className='listBtnB'>
                    <button onClick={this.changeList} value={23}>
                      東排灣語
                    </button>
                    <button onClick={this.changeList} value={24}>
                      北排灣語
                    </button>
                    <button onClick={this.changeList} value={25}>
                      中排灣語
                    </button>
                    <button onClick={this.changeList} value={26}>
                      南排灣語
                    </button>
                  </div>
                )}
                {this.state.abMain == 6 && (
                  <div className='listBtnB'>
                    <button onClick={this.changeList} value={27}>
                      東魯凱語
                    </button>
                    <button onClick={this.changeList} value={28}>
                      霧台魯凱語
                    </button>
                    <button onClick={this.changeList} value={29}>
                      大武魯凱語
                    </button>
                    <button onClick={this.changeList} value={30}>
                      多納魯凱語
                    </button>
                    <button onClick={this.changeList} value={31}>
                      茂林魯凱語
                    </button>
                    <button onClick={this.changeList} value={32}>
                      萬山魯凱語
                    </button>
                  </div>
                )}
                <div className='listBtnA'>
                  <button onClick={this.changeList} value={33}>
                    太魯閣語
                  </button>
                  <button onClick={this.changeList} value={34}>
                    噶瑪蘭語
                  </button>
                  <button onClick={this.changeList} value={35}>
                    鄒語
                  </button>
                  <button onClick={this.openList} value={7}>
                    卑南語
                  </button>
                  <button onClick={this.changeList} value={42}>
                    雅美語
                  </button>
                  <button onClick={this.changeList} value={43}>
                    撤奇萊雅語
                  </button>
                  <button onClick={this.changeList} value={36}>
                    卡那卡那富語
                  </button>
                  <button onClick={this.changeList} value={37}>
                    拉阿魯哇語
                  </button>
                </div>
                {this.state.abMain == 7 && (
                  <div>
                    <div className='listBtnB'>
                      <button onClick={this.changeList} value={38}>
                        南王卑南語
                      </button>
                      <button onClick={this.changeList} value={39}>
                        知本卑南語
                      </button>
                      <button onClick={this.changeList} value={40}>
                        西群卑南語
                      </button>
                      <button onClick={this.changeList} value={41}>
                        建和卑南語
                      </button>
                    </div>
                    <div className='listBottom'></div>
                  </div>
                )}
              </div>
            )}
          </div>
          {!this.state.videoPage && (
            <div className='ContentBox'>
              <ul>
                {todos.map((gePost) => (
                  <li key={gePost.no}>
                    <div className='videoBox'>
                      <div className='videoBoxInA'>
                        <div>
                          <img src={gePost.img} alt={''} />
                        </div>
                        <div>
                          <button
                            onClick={this.gotoVideo}
                            value={gePost.no}
                            className='btnGoToVideo'>
                            點擊觀看
                          </button>
                        </div>
                      </div>
                      <div className='videoBoxInB'>
                        <div>
                          <div>課程{gePost.number}</div>
                          <div>{gePost.title}</div>
                        </div>
                        <div className='info'>{gePost.info}</div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )}
          {this.state.videoPage && (
            <div className='videoInnerPageBox'>
              <div className='videoBoxC'>
                <div>
                  <button onClick={this.returnTo} className='videoBack'>
                    返回
                  </button>
                </div>
                <div className='videoNo'>
                  課程{GEPostData[this.state.videoNo].number}
                </div>
                <div className='videoTitleB'>
                  {GEPostData[this.state.videoNo].title}
                </div>
              </div>

              <div className='videoYT'>
                <iframe
                  width='880'
                  height='495'
                  src={GEPostData[this.state.videoNo].youtube}
                  title='YouTube video player'
                  frameBorder='0'></iframe>
              </div>
              <div className='videoBtnBox'>
                {this.state.videoNo != 0 && (
                  <button onClick={this.preLesson}>上一課</button>
                )}
                {this.state.videoNo != 9 && (
                  <button onClick={this.nextLesson}>下一課</button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default GEVideo;
